import type { BoxProps } from '@chakra-ui/react';
import { Box, useToken } from '@chakra-ui/react';

interface ContainerProps extends BoxProps {
  insetBorder?: boolean;
}

export function Container({ insetBorder = true, ...props }: ContainerProps) {
  const borderColor = useToken('colors', 'blackAlpha.250');

  return (
    <Box
      borderRadius="xl"
      width="100%"
      overflow="hidden"
      position="relative"
      bg="gray.100"
      _after={
        insetBorder
          ? {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              borderRadius: 'xl',
              boxShadow: `inset 0 0 0 1px ${borderColor}`,
            }
          : {}
      }
      {...props}
    />
  );
}
